exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content-heading{margin-top:10px;margin-left:29px;color:#7b7bd4}.content-title{color:gray;margin:10px;text-align:justify;margin-right:23px}.content-menu{color:gray;margin-left:23px;text-align:justify;margin-right:23px}.card-scroll{max-height:300px;overflow-y:auto;overflow-x:hidden}.attestation-checkbox{align-items:flex-start !important;margin-top:-37px !important}.select-input-center select{padding:19px 12px 18px}.text-input-center input{padding:19px 12px 18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Product/SharedComponents/Attestation/Attestation.scss
// module id = 1819
// module chunks = 101